export function imprimir(html) {
  //Esta funcion recibe un HTML por parametro y crea el documento necesario para imprimir.

  var mywindow = window.open('', 'PRINT', 'height=860,width=1024');
  mywindow.document.write('<html><head><title></title>');
  // mywindow.document.write("<style> footer {font-size: 9px;color: #f00;text-align: center;}@page {size: A4;margin: 11mm 17mm 17mm 17mm;}@media print {footer {position: fixed;bottom: 0;}.content-block, p {page-break-inside: avoid;} html, body {width: 210mm;height: 297mm;}} </style>");
  mywindow.document.write(
    "<style> @media screen { header.onlyprint, footer.onlyprint{ display: none; /* Hide from screen */ } } @media print { header.onlyprint { position: fixed; /* Display only on print page (each) */ top: 0; /* Because it's header */ } footer.onlyprint { position: fixed; bottom: 0; /* Because it's footer */ } @page { margin: 0; size: A4; } html, body { margin: 0; padding: 0; } } </style>"
  );
  mywindow.document.write('</head><body >');
  // mywindow.document.write('<header class="onlyprint">Contenido del Header</header>');

  mywindow.document.write(
    '<div style="margin: 15mm 10mm 15mm 10mm; min-height: calc(100vh - 30mm);" '
  );
  mywindow.document.write('<div>');
  mywindow.document.write(html);

  mywindow.document.write('</div>');
  mywindow.document.write('</div>');
  // mywindow.document.write('<footer class="onlyprint"> Direccion General de Informatica </footer>');
  mywindow.document.write('</body></html>');
  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10
  mywindow.print();
  setTimeout(() => mywindow.close(), 1000);
}
